<template >
  <div class="dzsgl" style="overflow-y: auto">
    <div style="text-align: left; font-size: 16px; padding-left: 10%; padding-right: 10%">
      <p style="font-weight: bold">本虚拟仿真实验教学平台依托由高等教育出版社出版，本项目负责人主编的浙江省普通本科高校“十四五”重点教材《Python程序设计（第2版）》建设。</p>
      <img src="../../assets/p.png" style="width: 100%">
      <img src="../../assets/p2.png" style="width: 100%">
      <p><br></p>
      <p>1. 教材简介</p><p>本教材主要面向初次学习Python语言的学生，分基础篇、进阶篇和高级篇3个阶段，由浅入深地系统讲解Python程序设计语言。编者团队已经建设《Python 100 one by one》慕课；搭建基于Python的虚拟仿真实验教学平台等配套教学资源。通过上述在线慕课学习和虚拟仿真实验，让学生能够快速掌握Python程序设计的思路和方法，并激发编程兴趣，从而培养学生的计算思维能力。在第1版的基础上，编者根据相关专家、教师和学生的反馈，并结合实践教学的需求与变化，进行了认真的修改和内容调整，并增加了相关配套教学资源。此外，在修订时特别关注了案例教学，精选100题经典程序设计例题，涵盖Python语言的重要知识点，并通过Step-by-Step的形式讲解，让零基础学生更容易掌握，改变其首次刚接触编程时无从下手的状态。</p><p>本教材体现了“新工科”建设思路，以推动人工智能、大数据等新一代信息技术与各学科专业深度融合，创新多学科交叉的人才培养为目标。立足于培养学生的互联网+思维模式和信息技术素养，并且有机地融入了课程思政元素，致力于培养学科交叉融合的复合型卓越人才，将行业背景与Python语言深度融合。全书以财经类高校为建设背景，全面体现了财经类专业特色，此外，教材还增加了Python与人工智能和数据分析相关章节，总结梳理典型案例，引导学生将信息技术应用到自身专业相关行业中去。</p><p>2. 教材内容</p><p>Python是一种简单易学、免费开源、功能强大的高级程序设计语言，使用Python可以快速有效地实现面向对象编程。Python 简洁的语法以及对动态数据类型的良好支持，解释性语言的本质，再加上Python丰富的标准库和扩展库，特别适用于快速应用程序开发，已经广泛应用到众多领域中。</p><p>本书作为程序设计语言教材，系统地阐述了Python语言的工作原理、程序设计技术、实现方法及其应用。全书共11章，分3个阶段详细介绍了Python语言程序设计的环境与操作、数据与表达、输入与输出、控制与结构、模块与函数、对象与方法、库表与管理、用户与界面以及Python与数据分析和人工智能方面的内容。</p><p>本教材分为基础篇、进阶篇和高级篇3个部分。第1部分包括第1-4章，主要介绍Python的基本语法、数据类型、运算符等，让学生能够快速理解Python语言，建立基本的计算思维能力。第2部分包括5-8章，主要介绍函数、程序结构与异常处理、函授与模块、对象与方法、文件与数据库等，让学生掌握更复杂的面向对象编程技术。第3部分包括9-10章，主要根据目前的技术发展需求增加了基于Python语言的数据分析、人工智能等内容，让学生了解使用Python语言解决实际应用问题的真实案例。</p><p>此外，为了推动人工智能、大数据等新一代信息技术与各学科专业深度融合，创新多学科交叉的人才培养，结合我校计算机科学与技术学科科研特长，本书还特别增加了Python与人工智能和数据分析相关篇幅。全面覆盖了浙江省计算机等级考试、非计算机专业基础课、计算机专业课和财经类高校专业建设行业背景与知识点。</p><p>特别的，为了提高学习阅读体验，充分提高教材配套资源利用率，本书通过二维码等形式将各类配套资源嵌入到实体书对应章节，使读者能在任何时候都能通过随手扫描的方式随时随地获得各种需要的教学资源；同时对教学资源的修改不再受限于重印等外界条件，可以直接在线更新。</p><p>3. 教材特色与创新</p><p>本教材依托Python语言程序设计系列课程建设，经过近几年的精心构思策划，2018年被指定为浙江省“计算机等级考试”重点建设教材，在经过多方专家指导后于2019年正式出版，此次修订工作吸收了多方智慧，符合新时期“新工科”教材建设总体要求，迎合了课程思政建设需求，将人工智能、大数据等新一代信息技术与各学科专业深度融合，总结梳理了行业典型案例，集成了众多教学资源。</p><p>1）教材编写团队实力雄厚。主编杨柏林教授为省151第一层次人才，主讲语言类课程近20年；副主编及其他编者多是各类教学技能比赛获奖者，多年来长期从事计算机编程语言教学。课程所依托的软件工程专业是国家级一流本科专业建设点，计算机科学与技术学科是浙江省一流学科。</p><p>2）教辅资料齐备。课程配套资源除电子教案、源代码等常规资源外，还已建成课程配套网站(https://abook.hep.com.cn/1865451)，慕课资源(https://www.icourse163.org/course/HZIC-1454063185?utm_campaign=share&utm_medium=androidShare&utm_source=)，虚拟仿真实验教学平台（http://python.zjgsu.edu.cn/）。所有配套资源集成了电子教案、课堂录像、习题指导、编程实训系统、自我测试、上机考试系统等非常完善的功能。</p><p>3）在大数据和人工智能等领域应用广泛。目前本书已经被浙江财经大学、杭州电子科技大学和中央民族大学等多所高校作为计算机基础课指定教材使用，年需求量约5000册，得到了专家和一线教师的一致好评。</p><p>同时，为了扩大教材的影响力，编委与全国多所高等院校采用校际、院际合作的方式，广泛吸收不同的教学需求和经验。以本次修订工作为契机，深度</p><p>优化了内容结构，总结和梳理了各章节对应的典型案例，引导读者将新一代信代信息技术应用到自身专业相关应用中去。</p><p> </p>
      <div style="display: flex; flex-direction: column">
        <div>预览<a :href="url1" target="_blank">Python程序设计（第2版）.pdf</a></div>
        <div>下载<a :href="url2"  target="_blank">课件.zip</a></div>
        <div>下载<a :href="url3"  target="_blank">源代码.zip</a></div>
      </div>
    </div>
  </div>


</template>

<script>
import { uploadImgUrl,uploadPdfUrl,getExpScoreList,updateVideoInfo,delVideoInfo,qryVideoTypeList,authToken} from '../../request/api';

export default {
  data() {
    return {
      url1: window.__HEALTH_URL__.JC01,
      url2: window.__HEALTH_URL__.JC02,
      url3: window.__HEALTH_URL__.JC03,
      bookTypeList:[],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      checkAll: false,
      multipleSelection: [],
      tableData: [],
      search: '',
      updateForm: {
        typeId:'',
        id:'',
        title: '',
        introduce: '',
        keyWord: '',
        author: '',
        press: '',
        publishTime: '',
        coverUrl: '',
        pdfList:[]
      },
      rules: {
        typeId:[
          { required: true, message: '分类不能为空', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '书名不能为空', trigger: 'blur' },
          { max: 50, message: '长度小于50个字符', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '书名不能为空', trigger: 'blur' },
          { max: 200, message: '长度小于200个字符', trigger: 'blur' }
        ],
        keyWord: [
          { required: true, message: '关键字不能为空', trigger: 'blur' },
          { max: 50, message: '长度小于50个字符', trigger: 'blur' }
        ]
      },
      searchForm: {
        bookName: "",
        dateRange: []
      },
      dialogFormVisible: false,
      formLabelWidth: '120px',
      nowPage: 1,
      pageSize: 10,
      totalCount: 0,
      uploadImgUrl: "",
      uploadPdfUrl: "",
      authHeader: {
        Authorization: ""
      },
      imageUrl: "",
      pdfFileList: []
    };
  },
  methods: {
    initUploadUrl() {
      let param = {}
      this.uploadImgUrl = uploadImgUrl(param);
      this.uploadPdfUrl = uploadPdfUrl(param);
      this.authHeader.Authorization = authToken();
    },
    handleRemove(file, fileList) {
      this.pdfFileList = fileList;
      if (this.pdfFileList.length === 0) {
        this.updateForm.pdfList = [];
      } else {
        let newPdfList = []
        this.updateForm.pdfList.forEach(value => {
          this.pdfFileList.forEach(value1 => {
            if (value1.name === value.name) {
              newPdfList.push(value);
            }
          });
        });
        this.updateForm.pdfList = newPdfList
      }

    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.updateForm.coverUrl = res.data.url;
    },
    handleVideoSuccess(res, file) {
      if (this.updateForm.pdfList === null) {
        this.updateForm["pdfList"] = []
      }
      res.data.type = file.raw.type;
      this.updateForm.pdfList.push(res.data)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPNG) && isLt2M;
    },
    beforePdfUpload(file) {
      const isPdf = file.type === 'video/mp4';
      if (!isPdf) {
        this.$message.error('上传文件类只能是 mp4 格式!');
      }
      const isLt200M = file.size / 1024 / 1024 < 2048;
      if (!isLt200M) {
        this.$message.error('上传文件大小不能超过 2GB!');
      }
      return isPdf;
    },
    // 加载视频列表
    loadVideoList(){
      let param = {
        nowPage: this.nowPage,
        pageSize: this.pageSize,
        title: this.searchForm.bookName,
        startDate: this.searchForm.dateRange[0],
        endDate: this.searchForm.dateRange[1]
      }
      getExpScoreList(param).then(
        resp => {
          if (resp.code === 1) {
            // 渲染数据
            this.tableData = resp.data.dataList;
            // 添加分页
            this.totalCount = resp.data.totalCount
          } else {
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    },
    loadVideoTypeList(){
      let param = {
      }
      qryVideoTypeList(param).then(
        resp => {
          if (resp.code === 1) {
            // 渲染数据
            this.bookTypeList = resp.data;
          } else {
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    },
    /**
     * 页码点击事件
     */
    handleCurrentChange (val) {
      // 清空之前状态
      this.tableData = []
      this.checkAll = false
      console.log('当前页：' + val)

      this.nowPage = val
      this.loadVideoList();
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.updateForm.id=''
      this.updateForm.title=''
      this.updateForm.introduce=''
      this.updateForm.keyWord=''
      this.updateForm.author=''
      this.updateForm.press=''
      this.updateForm.publishTime=""
      this.imageUrl=''
      this.updateForm.pdfList = []
      this.pdfFileList=[]
    },
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.updateForm = row
      this.imageUrl = row.coverUrl
      if (row.pdfList != null) {
        this.pdfFileList = row.pdfList
      }
    },
    batchDeleteHandler(){
      let idList = []
      this.multipleSelection.forEach(function (obj, index, array) {
        idList.push(obj.id)
      });
      let param = {
        idList: idList
      }
      this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log("请求:" + param)
        delVideoInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message({
                type: 'success',
                message: '批量删除成功!'
              });
              // 渲染数据
              this.loadVideoList();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDelete(row) {
      this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let param = {
          idList: [row.id]
        }
        delVideoInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // 渲染数据
              this.loadVideoList();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSubmit() {

      if (this.updateForm.coverUrl === '') {
        this.$message.error('封面不能为空!');
        return
      }

      if (this.updateForm.pdfList.length === 0) {
        this.$message.error('文件不能为空!');
        return
      }

      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          console.log("文件的列表:" + this.pdfFileList)
          this.dialogFormVisible = false
          let param = this.updateForm;
          updateVideoInfo(param).then(
            resp => {
              if (resp.code === 1) {
                this.$message.success(resp.msg);
                // 重置列表
                this.loadVideoList();
              } else {
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      console.log("这个val是多少： " + val)
      this.multipleSelection = val;
    }
  },
  mounted() {
    // 加载书籍分类列表
    this.loadVideoTypeList();
    // 加载列表
    this.loadVideoList();
    // 加载上传组件信息
    this.initUploadUrl();
  },
  props: ["itemData"]
};
</script>

<style lang="less">
.dzsgl{
  background-color: #EFF3FF;
  padding: 20px;
  height: calc(100vh - 200px);
}
.el-table th.el-table__cell{
    background-color: #EFF3FF;
  }

  .searchClass{
    width: 900px;
    height: 70px;

  }

.searchClass .el-form-item__content {
  margin-top: 13px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
  .avatar-uploader{
    text-align: left;
  }
  .upload-demo{
    text-align: left;
  }
.dzsgl .el-table .el-table__body-wrapper{
  height: calc(100vh - 355px);
  min-height: 250px;
  overflow-y: auto;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

.el-select {
  width: 100%;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  padding-left: 10px;
  padding-right: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/jc/spsgl.vue